import { useTranslation } from "react-i18next";
import * as z from "zod";

export const useBillNumberFormSchema = () => {
  const { t } = useTranslation();

  return z.object({
    billNumber: z
      .string({
        required_error: t(
          "billNumberForm.form.fields.billNumber.errors.required",
        ),
      })
      .min(1, t("billNumberForm.form.fields.billNumber.errors.required")),
  });
};
